import { render, staticRenderFns } from "./prize-code.vue?vue&type=template&id=0884f6b4&scoped=true"
import script from "./prize-code.vue?vue&type=script&lang=js"
export * from "./prize-code.vue?vue&type=script&lang=js"
import style0 from "./prize-code.vue?vue&type=style&index=0&id=0884f6b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884f6b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0884f6b4')) {
      api.createRecord('0884f6b4', component.options)
    } else {
      api.reload('0884f6b4', component.options)
    }
    module.hot.accept("./prize-code.vue?vue&type=template&id=0884f6b4&scoped=true", function () {
      api.rerender('0884f6b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/iframe-page/components/form-b/prize-code.vue"
export default component.exports